import { Typography } from "@mui/material";

export enum CALLOUT_STATUS {
    INFO = 'info',
    SPECIAL = 'special',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',

}
// Extracting the type as a string
export type CalloutStatusType = `${CALLOUT_STATUS}`; // Results in "info" | "success" | "warning" | "error"


interface IProps {
    type: CalloutStatusType;
    text: string;
}
/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function CallOutComponent({ type, text }: IProps) {

    return (<aside className={`MuiCallout-root MuiCallout-${type}`}>
        <div className="MuiCallout-content" style={{ padding: '4px', margin: 0, width: '100%' }}>
            <Typography textAlign='center' width='100%'>
                {text}
            </Typography>
        </div>
    </aside>);
}